const FolderEmail = ({ width, height, color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 220 120"
    width={width || '120'}
    height={height || '220'}
    {...props}
  >
    <g fill={color || '#6E6E6E'}>
      <path d="M117.5 47.5A2.501 2.501 0 00120 45V15a2.5 2.5 0 00-2.5-2.5H105v-5A7.498 7.498 0 0097.5 0h-85A7.5 7.5 0 005 7.5v5H2.5a2.5 2.5 0 000 5H5v10H2.5a2.5 2.5 0 000 5H5v10H2.5a2.5 2.5 0 000 5H5v10H2.5a2.5 2.5 0 000 5H5v10H2.5a2.5 2.5 0 000 5H5v10H2.5a2.5 2.5 0 000 5H5v10H2.5a2.5 2.5 0 100 5H5v5a7.499 7.499 0 007.5 7.5h85a7.497 7.497 0 007.5-7.5v-5h12.5a2.5 2.5 0 002.5-2.5c0-48.275.475-46.25-1.375-47.2-.85-.45-1.325-.3-13.625-.3v-10h12.5zm-2.5-5H75v-25h40v25zM70 35H45V25h25v10zm-60 77.5v-5h2.5a2.5 2.5 0 100-5H10v-10h2.5a2.5 2.5 0 000-5H10v-10h2.5a2.5 2.5 0 000-5H10v-10h2.5a2.5 2.5 0 000-5H10v-10h2.5a2.5 2.5 0 000-5H10v-10h2.5a2.5 2.5 0 000-5H10v-10h2.5a2.5 2.5 0 000-5H10v-5A2.5 2.5 0 0112.5 5H20v110h-7.5a2.5 2.5 0 01-2.5-2.5zm40-10V64.85l31.05 22.175a2.5 2.5 0 002.9 0L115 64.85v37.65H50zm59.7-40L82.5 81.925 55.3 62.5h54.4zm-9.7-5c-53.4 0-54.625-.9-55 2.25V105a2.501 2.501 0 002.5 2.5H100v5a2.501 2.501 0 01-2.5 2.5H25V5h72.5a2.5 2.5 0 012.5 2.5v5H72.5A2.5 2.5 0 0070 15v5H42.5a2.5 2.5 0 00-2.5 2.5v15a2.5 2.5 0 002.5 2.5H70v5a2.5 2.5 0 002.5 2.5H100v10z" />
      <path d="M85 27.5h22.5a2.501 2.501 0 000-5H85a2.5 2.5 0 000 5zM100 32.5H85a2.5 2.5 0 000 5h15a2.501 2.501 0 000-5z" />
    </g>
  </svg>
);

export default FolderEmail;
